// Copyright (c) 2016 Deere & Company

import './customer-panel.scss';
import * as customerService from '../../../product/shared/services/customer';
import React, {PropTypes} from 'react';
import {
    buildCityStateZip,
    buildCustomerAddress,
    buildEmailLink,
    buildPhoneNumber
} from '../../../product/shared/services/product';
import ActionsPopover from '../../../shared/components/actions-popover';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import {FormattedMessage} from 'react-intl';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';

/* eslint-disable react/no-multi-comp */
/* eslint-disable complexity */

const customerDetailsPrivateTrue = productDetails =>
    productDetails.product.customerPrivate && productDetails.customer.ckcId ?
        <div>{customerService.customerDisplayText(productDetails.customer)}</div> :
        <FormattedMessage id='NO_CUSTOMER_ASSOCIATED'/>;

const customerDetailsPrivateFalse = customerDetails =>
        !customerDetails.product.customerPrivate && customerDetails.customer.ckcId ?
            <main>
                <a
                    className='name'
                    href={`#/products/products-by-customer?ckcId=${customerDetails.customer.ckcId}`}
                >
                    {customerService.customerDisplayText(customerDetails.customer)}
                </a>
                <div className='line1'>
                    {buildCustomerAddress(customerDetails.customer).line1}
                </div>
                <div className='line2'>
                    {buildCustomerAddress(customerDetails.customer).line2}
                </div>
                <div className='city-state-zip'>
                    {buildCityStateZip(buildCustomerAddress(customerDetails.customer))}
                </div>
                <div className='country'>
                    {buildCustomerAddress(customerDetails.customer).country}
                </div>
                {customerDetails.customer.phone && customerDetails.customer.phone.length > 0 &&
                <div className='phone'>
                    {buildPhoneNumber(customerDetails.customer.phone[0])}
                </div>
            }
                <div className='email'>
                    <a href={buildEmailLink(customerDetails.customer.email)}>
                        {customerDetails.customer.email}
                    </a>
                </div>

                <section className='customer-button-group'>
                    <a
                        className='button-secondary'
                        href={`#/products/products-by-customer?ckcId=${customerDetails.customer.ckcId}`}
                        type='button'
                    >
                        <FormattedMessage id='VIEW_PRODUCTS'/>
                    </a>
                </section>
            </main> :
            customerDetailsPrivateTrue(customerDetails);

const CustomerPanel = props =>
    <section className='customer-panel'>
        <header className='customer-title'>
            <span className='customer-panel-title'><FormattedMessage id='CUSTOMER'/></span>
            {props.customerPanelActionList.length > 0 && props.showActionsButton &&
            <ActionsPopover
                options={props.customerPanelActionList}
                showCaret={true}
            />
            }
        </header>
        {props.isCkcCustomerFailed ?
            <div className='customer'>{customerService.customerDisplayText(props.product.customerSummary)}</div> :
            customerDetailsPrivateFalse(props)}
    </section>;

/* eslint-enable react/no-multi-comp */
/* eslint-enable complexity */

CustomerPanel.displayName = 'CustomerPanel';
CustomerPanel.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    customerPanelActionList: PropTypes.arrayOf(PropTypes.object),
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    showActionsButton: PropTypes.bool
};
CustomerPanel.defaultProps = {
    customerPanelActionList: [],
    showActionsButton: false
};

export default CustomerPanel;



// WEBPACK FOOTER //
// ./src/shared/components/customer-panel/customer-panel.js